<template>
	<div class="color-box" v-if="resultData">
		<div class="color-item">
			<span class="label">{{ $t("sheng_chan_ri_qi") }}: </span>{{ resultData.production_date || "-" }}
		</div>
		<div class="color-item">
			<span class="label">{{ $t("ext_yan_se") }}: </span>{{ resultData.ext_color || "-" }}
		</div>
		<div class="color-item">
			<span class="label">{{ $t("int_yan_se") }}: </span>{{ resultData.int_color || "-" }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		resultData: {
			type: Object,
			default() {
				return {};
			},
		},
	},

	data() {
		return {};
	},

	mounted() {},

	methods: {},
};
</script>

<style scoped lang="less">
.color-box {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-top: 30px;
	.color-item {
		margin-right: 58px;
		span {
			font-family:
				PingFangSC,
				PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}
	}
}
</style>
